export const handleWhatsappUrl = (whatsapp) => {
  if (!whatsapp.includes('https')) {
    whatsapp = `https://api.whatsapp.com/send?phone=${whatsapp}&text=${encodeURI('Hola!!')}&app_absent=0`
  }
  return whatsapp
}
